import { getIsTrainIncident } from '@rsos/base-utils';
import { ACCEPTED } from '@rsos/constants/alertStatuses';
import { ACTIVE_ASSAILANT } from '@rsos/constants/alertTypes';
import { EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import {
  getAlertMarkerIcon,
  getAlertMarkerHoverIcon,
  getAlertMarkerSize,
} from './alertMarkerIcons';

/**
 * Util function to check if it is an AAA and if it is unaccepted. Returns boolean
 * @param {Object} alert - full alert object
 */

export const getIsUnacceptedActiveAssailant = alert => {
  return (
    alert?.emergency_type?.name === ACTIVE_ASSAILANT &&
    alert?.status?.name !== ACCEPTED
  );
};

/**
 * Util function to check if it is a train alert and if it is unaccepted. Returns boolean
 * @param {Object} alert - full alert object
 */

export const getIsUnacceptedTrainIncident = alert => {
  return (
    getIsTrainIncident(alert?.emergency_type?.name, true) &&
    alert?.status?.name !== ACCEPTED
  );
};

// update marker's icon for hover and recover
export const updateMarkerIcon = (
  marker,
  alert,
  activeQueueTab,
  isAllView,
  isMostRecent,
  type,
) => {
  const isOpaque =
    !isRegularAlert(alert) &&
    alert.status.name === ACCEPTED &&
    activeQueueTab === EMERGENCY_CALLS;
  const markerIcon =
    type === 'hover'
      ? getAlertMarkerHoverIcon(isAllView, isMostRecent, alert, isOpaque)
      : getAlertMarkerIcon(isAllView, isMostRecent, alert, isOpaque);
  const iconSize = getAlertMarkerSize(isAllView, isMostRecent);
  const options = {
    icon: markerIcon,
    iconSize,
  };
  return marker.changeMarkerIcon(options);
};

/**
 * Takes an array of items and a condition that each element will be evaluated against
 * returns 2 arrays: one with the elements that have the condition evaluated as true and
 * another one with the elements that have the condition evaluated as false
 * @param {Array} list - array of elements
 * @param {Function} - condition to evaluate each element against
 */

export function divideArrayByCondition(array, evalCondition) {
  return array.reduce(
    ([pass, fail], elem) => {
      return evalCondition(elem)
        ? [[...pass, elem], fail]
        : [pass, [...fail, elem]];
    },
    [[], []],
  );
}

/**
 * Util function to filter all markers by alert types and return them in groups
 * @param {Array} allMarkers - an array of all markers
 * @param {Object} allAlerts - an object containing alerts to iterate through
 */

export function resolveMarkers(allMarkers = [], allAlerts) {
  let aaaMarkers = [],
    regularMarkers = [],
    trainMarkers = [],
    testMarkers = [];

  allMarkers.forEach(m => {
    const resolvedAlertByMarker = allAlerts[m.custom.alertID];
    const alertType = resolvedAlertByMarker?.emergency_type?.name;
    const isTrainIncident = getIsTrainIncident(alertType, true);

    if (resolvedAlertByMarker && alertType) {
      if (alertType === ACTIVE_ASSAILANT) {
        aaaMarkers = [...aaaMarkers, m];
      } else if (isTrainIncident) {
        trainMarkers = [...trainMarkers, m];
      } else if (alertType.startsWith('TEST')) {
        testMarkers = [...testMarkers, m];
      } else {
        regularMarkers = [...regularMarkers, m];
      }
    }
  });
  return {
    aaaMarkers: aaaMarkers,
    regularMarkers: regularMarkers,
    trainMarkers: trainMarkers,
    testMarkers: testMarkers,
  };
}

/**
 * Util function to check if the alert is regular or if it belongs to AAA or Train Incident alerts
 * @param {Object} alert - full alert object
 */

export function isRegularAlert(alert) {
  return (
    alert &&
    alert.emergency_type.name !== ACTIVE_ASSAILANT &&
    !getIsTrainIncident(alert.emergency_type.name) &&
    !alert.emergency_type.name.startsWith('TEST')
  );
}
